export default __webpack_public_path__ + "static/media/rodrigue.704d8dff.jpg";